import { createSlice } from '@reduxjs/toolkit'
import appConfig from 'configs/app.config'

const initialState = {
    currentLang: appConfig.locale,
    currentLangId: 1
}

export const localeSlice = createSlice({
    name: 'locale',
    initialState,
    reducers: {
        setLang: (state, action) => {
            const { lang, langId } = action.payload
            state.currentLang = lang
            state.currentLangId = langId
        },
    },
})

export const { setLang } = localeSlice.actions

export default localeSlice.reducer
